/*
 * @Author: chenguanghua
 * @Date: 2022-07-26
 * @LastEditors: DQL
 * @LastEditTime: 2022-07-30 16:29:57
 * @Description: 代办报告项目
 */

import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

export const dbbgManageService = {
  // 查询
  query: (params) => { return axios.get(`${iffApi}/dbbg`, { params: params }); },

  // 查看
  getDetail: (id) => { return axios.get(`${iffApi}/dbbg/${id}`); },

  // 删除
  delete: (id) => { return axios.delete(`${iffApi}/dbbg/${id}`); },

  // 导出
  export: (params) => { return axios.get(`${iffApi}/dbbg/export`, { responseType: 'blob', params }); }

};
